"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shopultafilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shopultafilled` : '') + (description ? ` desc-shopultafilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shopultafilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shopultafilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#232323",
    d: "M14.898 5.095c2.785 0 5.117 2.337 5.117 5.312s-2.332 5.312-5.117 5.312c-2.784 0-5.115-2.337-5.116-5.312s2.332-5.312 5.116-5.312"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#232323",
    fillRule: "evenodd",
    d: "M14.915 2a8.243 8.243 0 0 1 8.068 8.375l-.002.408a8.24 8.24 0 0 1-2.596 5.763l3.434 4.2a.75.75 0 1 1-1.16.95L19.2 17.468a8.24 8.24 0 0 1-4.317 1.31 8.246 8.246 0 0 1-8.069-8.404A8.24 8.24 0 0 1 14.884 2zm-.017 1.595c-3.654 0-6.616 3.05-6.616 6.812l.009.35c.177 3.6 3.068 6.462 6.607 6.462s6.43-2.863 6.608-6.462l.009-.35c0-3.762-2.963-6.812-6.617-6.812",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#232323",
    d: "M6.337 15.347c.291.527.632 1.03 1.018 1.5H.75a.75.75 0 0 1 0-1.5zM5.093 10.45q-.005.705.088 1.397H.75a.75.75 0 0 1 0-1.5h4.343zM6.383 5.347q-.407.722-.69 1.5H.75a.75.75 0 0 1 0-1.5z"
  }));
};
var _default = exports.default = shopultafilled;